const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: '640px',
  },
  header: {
    fontSize: '18px',
    fontWeight: 500,
    padding: '8px 0px',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#838D98',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    gap: '8px',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '20px',
  },
})

export default styles
